import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, map, of } from 'rxjs';
import { getCustomerSignedIn, Product } from 'src/app/shop';
import { LandingPage } from '../../models';

import * as fromStore from '../../store';
import { Header } from 'src/app/core/models';
import { HeaderSliderComponent } from '../../components/header-slider/header-slider.component';
import { HeaderArticleComponent } from '../../../core/components/header-article/header-article.component';
import { ContentBlockContainerComponent } from '../../../content-blocks/containers/content-block-container/content-block-container.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderSliderComponent, HeaderArticleComponent, ContentBlockContainerComponent, AsyncPipe],
})
export class LandingPageComponent implements OnInit {
  private store = inject(Store);

  landingPage$!: Observable<LandingPage>;
  slides$: Observable<Header[]> = of([]);
  signedIn$!: Observable<boolean>;

  ngOnInit(): void {
    this.landingPage$ = this.store.select(fromStore.getSelectedLandingPage);
    this.signedIn$ = this.store.select(getCustomerSignedIn);
    this.slides$ = this.landingPage$.pipe(map(a => a && [a.header, ...a.headerSlides]));
  }

  hasHeader(obj: any) {
    return Object.values(obj).every(value => !!value) || !!obj?.image?.url;
  }
}
